import { ReactNode } from 'react';
import { Flex, FlexProps } from '@blockanalitica/ui';

export interface SparkTitleProps extends FlexProps {
  children: ReactNode;
}

export default function SparkTitle({ children, ...rest }: SparkTitleProps) {
  return (
    <Flex {...rest} name="sparkTitle">
      {children}
    </Flex>
  );
}
